import { useState } from "react";
import { BbotButton, BbotTag, SettingsCard } from "top-component-library";
import { CONFIG_TYPE_PRETTY_NAME } from "../constants";
import EnableBasicDeliveryThemeDialog from "./EnableBasicDeliveryThemeDialog";

// Mirrors edit-hostname-configs.html's "Menu-only BOS" card. Admin-only.
const MenuOnlyBosCard = ({ hostnameConfig, onEnableBasicDeliveryTheme }) => {
  const { configType, hostname, canEdit, redirect_to_delivery_location: redirectToDeliveryLocation } = hostnameConfig;
  const [showDialog, setShowDialog] = useState(false);
  const isEnabled = configType === "basicDeliveryTheme";

  return (
    <SettingsCard title="Menu-only BOS">
      <div>
        <p>
          (Admin only) Sets up a basic theme for delivery/pickup that redirects to a given delivery location when
          patrons navigate to <strong>{hostname}</strong>
        </p>
        {configType === "notConfigured" ? (
          <p>No configuration option has been chosen. Choose this configuration by pressing the enable button.</p>
        ) : isEnabled ? (
          <p>
            Guests will be shown the menu page when visiting <strong>{hostname}</strong>. You&apos;re currently
            redirecting to table code: <strong>{redirectToDeliveryLocation?.locationShortId}</strong>
          </p>
        ) : (
          <p>
            The current configuration setting is <strong>{CONFIG_TYPE_PRETTY_NAME[configType]}</strong>. Enabling this
            configuration will overwrite it.
          </p>
        )}
        <div>
          {isEnabled && <BbotTag color="green">Enabled</BbotTag>}
          <BbotButton type={isEnabled ? undefined : "primary"} onClick={() => setShowDialog(true)} disabled={!canEdit}>
            {isEnabled ? "Change Settings" : "Enable"}
          </BbotButton>
        </div>
      </div>
      <EnableBasicDeliveryThemeDialog
        visible={showDialog}
        hostnameConfig={hostnameConfig}
        onClose={() => setShowDialog(false)}
        onSave={onEnableBasicDeliveryTheme}
      />
    </SettingsCard>
  );
};

export default MenuOnlyBosCard;
